export enum ImportType {
  MANUAL = "MANUAL",
  IMPORT_EQUADVICE = "IMPORT_EQUADVICE",
  IMPORT_DIRECTORY = "IMPORT_DIRECTORY"
}